var Console = {
	
	clear: function() {
		$("#console").html("");
	},
	
	place: function(symbol, xx, yy, val) {
		node = $("#" + symbol);
		
		if (!node.length) {
			node = $("<div style='color:#ffffff;position:absolute;left:" + xx + "px;top:" + yy + "px' id='" + symbol + "'></div>");
			$("#console").append(node);
		}
								
		node.html(val);
	},
	
	put: function(symbol, xx, yy, val) {
		this.place(symbol, xx, yy, symbol + ":" + val);
	}
	
}